import React from 'react';
import { motion } from 'framer-motion';
import { BoxIcon } from 'lucide-react';
interface ServiceCardProps {
  icon: BoxIcon;
  title: string;
  description: string;
  delay?: number;
}
export function ServiceCard({
  icon: Icon,
  title,
  description,
  delay = 0
}: ServiceCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} whileHover={{
    y: -4,
    boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
  }} className="bg-white p-6 rounded-xl border border-neutral transition-all duration-300 cursor-pointer" data-id="element-87">
      <div className="w-12 h-12 bg-surface rounded-lg flex items-center justify-center mb-4" data-id="element-88">
        <Icon className="w-6 h-6 text-primary" data-id="element-89" />
      </div>
      <h3 className="text-xl font-bold text-ink mb-2" data-id="element-90">{title}</h3>
      <p className="text-gray-600 leading-relaxed" data-id="element-91">{description}</p>
    </motion.div>;
}